
import request from "@/utils/request";
const index = {
  // 详情
  detail(query) {
    return request({
      url: "/jiejiCommInfo/detail",
      method: "post",
      params: query
    });
  },
  // 编辑
  edit(data) {
    return request({
      url: "/jiejiCommInfo/edit",
      method: "post",
      data
    });
  },
};
export default index;